// extracted by mini-css-extract-plugin
module.exports = {"container":"Loader_container__IKaco","dot":"Loader_dot__D7oAh","reveal":"Loader_reveal__TRwsx","slide":"Loader_slide__eNGyr"};